import React from "react";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { RoutePaths } from "src/app/model";
import { ServicesCards } from "src/widgets/ServicesCards";

export const ServicesPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Stack
      id={RoutePaths.SERVICES}
      width={1}
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap={2}
      sx={{
        scrollMarginTop: 80,
      }}
    >
      <Typography
        color="text.secondary"
        variant="h5"
        fontWeight="light"
        sx={{
          opacity: 0.8,
          fontSize: { sm: "1.5rem", xs: "1rem" },
        }}
      >
        {t("services.eyebrow")}
      </Typography>

      <Typography
        variant="h3"
        fontWeight={300}
        borderBottom={1}
        color="text.secondary"
        borderColor="primary.main"
        sx={{
          fontSize: {
            lg: "3rem",
            md: "2.75rem",
            sm: "2.5rem",
            xs: "2rem",
          },
        }}
      >
        {t("services.titleMain")}{" "}
        <Typography
          component="span"
          color="primary"
          variant="inherit"
          fontWeight="inherit"
        >
          {t("services.titleAccent")}
        </Typography>
      </Typography>

      <Typography
        color="text.primary"
        variant="body1"
        maxWidth="50%"
        textAlign="center"
        sx={{
          maxWidth: {
            lg: 0.5,
            md: 0.7,
            sm: 0.8,
            xs: 0.9,
          },
        }}
      >
        {t("services.intro")}
      </Typography>

      <ServicesCards />
    </Stack>
  );
};
